const enum ProductListEnumType {
   PublicList = 10,
  PrivateList = 20,
  QuoteList = 30,
  BranchList = 40,
  VirtualList = 50,
}

export default ProductListEnumType;